// The tuning panel is for us, not players: it opens with ?tune on the dev
// server and on staging, and stays open for the rest of the tab's session
// (navigation drops the query string).
const FLAG = 'wits.tune';

export function tuningEnabled(): boolean {
  if (typeof window === 'undefined') return false;
  const host = location.hostname;
  const allowed = import.meta.env.DEV || host === 'localhost' || host.startsWith('staging.');
  if (!allowed) return false;
  try {
    if (new URLSearchParams(location.search).has('tune')) sessionStorage.setItem(FLAG, '1');
    return sessionStorage.getItem(FLAG) === '1';
  } catch {
    return new URLSearchParams(location.search).has('tune');
  }
}
